export default __webpack_public_path__ + "static/media/inklink interior2.f0a302b9.jpg";